import { render, staticRenderFns } from "./depthChartNhl.vue?vue&type=template&id=56d8406a"
import script from "./depthChartNhl.vue?vue&type=script&lang=js"
export * from "./depthChartNhl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports